import { Avatar, AvatarImage } from "@/components/ui/avatar";
import { useTranslation } from "@/hooks/useTranslation";
import {
  AdminUserHistoryDTO,
  UserHistoryCompaniesExport,
  UserHistoryTargetListingAddCompanies,
  UserHistoryTargetSaveCompanyFromTag,
} from "@shaarp/common";
import { NavLink } from "react-router-dom";

export default function DataTableCellAdminUsersHistoryTarget({
  userHistory,
}: {
  userHistory: AdminUserHistoryDTO;
}) {
  const { t } = useTranslation();

  switch (userHistory.action) {
    case "LISTING_ADD_COMPANIES":
      const listingData =
        userHistory.data as UserHistoryTargetListingAddCompanies;
      return `Ajout de ${listingData.companiesIds?.length || "?"} entreprises à une liste`;
    case "EXPORT_COMPANIES":
      const exportData = userHistory.data as UserHistoryCompaniesExport;
      return `Export de ${exportData.companiesIds?.length || "?"} entreprises au format ${exportData.format}`;
    case "SAVE_COMPANY_FROM_TAG": {
      const savedCount = (
        userHistory.data as UserHistoryTargetSaveCompanyFromTag
      ).companiesIds?.length;
      return t("components.dataTableUsersHistory.target.saveCompaniesFromTag", {
        count: savedCount ?? 0,
      });
    }
    case "PREVIEW_COMPANY":
      // A company known only from the web has no page to link to.
      if (!userHistory.metadata.company?.id) {
        return t("components.dataTableUsersHistory.target.previewCompanyOffBase");
      }
      break;
    default:
      break;
  }

  if (!userHistory.metadata.company || !userHistory.metadata.company.id) {
    const keys = Object.keys(userHistory.data);
    // @ts-expect-error data is a generic type
    return keys.map((key) => `${key}: ${userHistory.data[key]}`).join(" / ");
  }

  return (
    <NavLink
      to={`/company/${userHistory.metadata.company.id}`}
      className="flex items-center"
    >
      <Avatar className="w-9 h-9">
        <AvatarImage
          src={
            userHistory.metadata.company.logo ??
            userHistory.metadata.company.thumbnail
          }
          alt={userHistory.metadata.company.name}
        />
      </Avatar>
      <span className="ml-2">{userHistory.metadata.company.name}</span>
    </NavLink>
  );
}
